var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM13.5 9C14.33 9 15 8.33 15 7.5C15 6.67 14.33 6 13.5 6C12.67 6 12 6.67 12 7.5C12 8.33 12.67 9 13.5 9ZM6.5 9C7.33 9 8 8.33 8 7.5C8 6.67 7.33 6 6.5 6C5.67 6 5 6.67 5 7.5C5 8.33 5.67 9 6.5 9ZM10 15.5C12.03 15.5 13.8 14.39 14.75 12.75C14.7932 12.6733 14.8156 12.5867 14.8148 12.4987C14.814 12.4107 14.7902 12.3244 14.7457 12.2485C14.7011 12.1726 14.6375 12.1097 14.561 12.0661C14.4846 12.0225 14.398 11.9997 14.31 12H5.69C5.31 12 5.06 12.42 5.25 12.75C5.73076 13.5849 6.42281 14.2786 7.2566 14.7613C8.09039 15.2441 9.03655 15.4988 10 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood);
export default __webpack_public_path__ + "static/media/Mood.41f960c2a946c813698288ac309dcf44.svg";
export { ForwardRef as ReactComponent };